import React from "react";

/**
 * The header every section on this page opens with: a numbered label, then a
 * title, then an optional lede.
 *
 * It exists because eight sections were each writing their own version of the
 * same three lines. One component means the numbering, the rule length, the
 * colours and the spacing are identical down the whole page — which is most of
 * what makes a long page read as tidy rather than as eight designs stacked.
 *
 * Mirrors the site's existing `SectionHeading` in tone and type scale; the
 * only thing it adds is the running index, which is the thread tying the nine
 * sections together.
 */

function SectionIntro({
  index,
  label,
  title,
  lede,
  tone = "light",
  align = "left",
  className = ""
}) {
  const dark = tone === "dark";
  const centred = align === "center";

  return (
    <div className={`${centred ? "mx-auto max-w-3xl text-center" : "max-w-2xl"} ${className}`}>
      <div className={`flex items-center gap-4 ${centred ? "justify-center" : ""}`}>
        <span className={`mw-eyebrow ${dark ? "text-[#D8B4FE]" : "text-[#6A0DAD]"}`}>
          {index}
        </span>
        <span
          className={`h-px w-10 ${dark ? "bg-white/25" : "bg-[#1E1B16]/20"}`}
          aria-hidden="true"
        />
        <span className={`mw-eyebrow ${dark ? "text-white/70" : "text-[#4D4B46]"}`}>
          {label}
        </span>
      </div>

      {title ? (
        <h2 className={`mw-h2 mt-5 ${dark ? "text-white" : "text-[#1E1B16]"}`}>
          {title}
        </h2>
      ) : null}

      {lede ? (
        <p className={`mw-lede mt-5 ${dark ? "text-[#DCC9F2]" : "text-[#4D4B46]"}`}>
          {lede}
        </p>
      ) : null}
    </div>
  );
}

export default SectionIntro;
